module.exports = __webpack_public_path__ + "4d251399c535cb75318c642c9132b4b4.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/up-2.png
// module id = 3065
// module chunks = 0